import { useState } from "react";
import { useNavigate } from "react-router-dom";
import OnboardingShell from "./_Shell";
import { getOrCreateOnboarding, saveOnboarding } from "../../lib/onboarding";

export default function OnboardingStep2() {
  const navigate = useNavigate();
  const ob = getOrCreateOnboarding();

  const [fullName, setFullName] = useState(
    (ob.step2 as Record<string, unknown>)?.fullName as string ?? ""
  );
  const [email, setEmail] = useState(
    (ob.step2 as Record<string, unknown>)?.email as string ?? ""
  );
  const [password, setPassword] = useState(
    (ob.step2 as Record<string, unknown>)?.password as string ?? ""
  );
  const [businessName, setBusinessName] = useState(
    (ob.step2 as Record<string, unknown>)?.businessName as string ??
      ob.step1?.businessName ??
      ""
  );
  const [phone, setPhone] = useState(
    (ob.step2 as Record<string, unknown>)?.phone as string ?? ""
  );

  const canContinue = Boolean(
    fullName.trim() && email.trim() && password.trim() && businessName.trim() && phone.trim()
  );

  function handleContinue() {
    saveOnboarding({
      ...ob,
      step2: { fullName, email, password, businessName, phone } as Parameters<typeof saveOnboarding>[0]["step2"],
    });
    navigate("/onboarding/3");
  }

  return (
    <OnboardingShell
      step={2}
      title="Let's set up your account"
      subtitle="You're 60 seconds from your first AI call."
    >
      <div className="grid gap-4">
        <Field
          label="Full name"
          value={fullName}
          onChange={setFullName}
          required
        />
        <Field
          label="Email"
          type="email"
          value={email}
          onChange={setEmail}
          autoComplete="username"
          required
        />
        <Field
          label="Password"
          type="password"
          value={password}
          onChange={setPassword}
          autoComplete="new-password"
          required
        />
        <Field
          label="Business name"
          value={businessName}
          onChange={setBusinessName}
          placeholder="e.g. Riverside Dental Group"
          required
        />
        <Field
          label="Main phone"
          value={phone}
          onChange={setPhone}
          required
        />

        <div className="flex gap-3 mt-2">
          <button
            type="button"
            onClick={() => navigate("/onboarding/1")}
            className="w-full rounded-xl border border-white/15 px-4 py-3 text-sm font-semibold text-white/90 hover:border-white/30 cursor-pointer"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Back
          </button>
          <button
            type="button"
            onClick={handleContinue}
            disabled={!canContinue}
            className="w-full rounded-xl px-4 py-3 text-sm font-semibold text-white transition-opacity disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
            style={{
              background: "linear-gradient(90deg, #8a2be2, #ff6a00)",
              fontFamily: "'Space Grotesk', sans-serif",
            }}
          >
            Continue →
          </button>
        </div>
      </div>
    </OnboardingShell>
  );
}

function Field(props: {
  label: string;
  value: string;
  onChange: (v: string) => void;
  required?: boolean;
  type?: string;
  autoComplete?: string;
  placeholder?: string;
}) {
  return (
    <div>
      <label
        className="block text-sm font-semibold text-white/85"
        style={{ fontFamily: "'Space Grotesk', sans-serif" }}
      >
        {props.label}
        {props.required ? " *" : ""}
      </label>
      <input
        type={props.type ?? "text"}
        className="mt-2 w-full rounded-xl border border-white/10 bg-slate-950/50 px-4 py-3 text-sm text-white outline-none focus:border-white/25"
        value={props.value}
        onChange={(e) => props.onChange(e.target.value)}
        autoComplete={props.autoComplete}
        placeholder={props.placeholder}
      />
    </div>
  );
}
